const DIALECTS_COARSE = 'dialects_coarse';
const DIALECTS_FINE = 'dialects_fine';
const DIALECTS_NONE = 'dialects_none';

export {
	DIALECTS_COARSE,
	DIALECTS_FINE,
	DIALECTS_NONE,
};
